import React from 'react';
import {MDBDataTable} from "mdbreact";
import {Empty} from "antd";
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import * as tbl_headers from '../user_group_table_headers_util';
import {Button as SementicBtn, Button, Radio} from "semantic-ui-react";
import * as innerRoutes from '../user_group_route_util';
import CreateUserGroupModal from "../CreateUserGroupModal";
import UpdateUserGroupModal from "../UpdateUserGroupModal";
import axios from "../../../axios/axios_tag";
import apiConfig from "../../../axios/axios_api_services";
import {withRouter} from "react-router-dom";
import Cookies from "js-cookie";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import * as common from "../../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import AddUsersModal from "../AddUsersModal";

class AllUserGroupsComponent extends React.Component {

  state = {
    corporateId: -1,
    corporateName: "",
    updateModal: false,
    createModal: false,
    userModal: false,
    userGroups: [],
    userGroup: null,
  };

  componentDidMount() {
    this.props.setUserGroupHandler(null);
    if(this.props.usr_obj!==null && this.props.usr_obj!==undefined) {
      let userRoles = this.props.usr_obj.userRoles;
      if(userRoles!=="SUPER") {
        let corporateName = this.props.usr_obj.corporates[0].corporateName;
        this.setState({
          corporateName: corporateName,
          corporateId: this.props.usr_obj.corporates[0].corporateId
        });
      }
    }

    this.getAllUserGroupOfCorporate();
  }

  createUserGroup =() => {
    this.setState({
      createModal: true,
    });
  };

  updateUserGroup =(userGroup) => {
    this.setState({
      updateModal: true,
      userGroup: userGroup
    });
  };

  navToUsers = (userGroup) => {
    this.props.setUserGroupHandler(userGroup);
    this.navToUsers_();
  };

  navToUsers_ = () => {
    this.props.history.push(innerRoutes.inner_route_tags_user_groups_users);
  };

  getAllUserGroupOfCorporate = () => {
    let corporateId = this.props.usr_obj.corporates[0].corporateId;
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };
    this.props.spinnerHandler(true);
    if(corporateId !== -1 && corporateId !== null && corporateId !== undefined) {
      axios.get(apiConfig.CORPORATE_USER_GROUPS( corporateId, 5000),{headers:headers}).then(r =>{
        this.setState({
          userGroups: r.data.userGroups
        });
      }).catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllUserGroupOfCorporate()
        }
      }).finally(fin => {
        this.props.spinnerHandler(false);
      });

    }
  };

  userGroupActivationUpdate = (index) => {
    let userGroups = this.state.userGroups;
    if(userGroups) {
      let userGroup = userGroups[index];
      let status = userGroup.status!==1?"activate":"deactivate";
      let groupName = userGroup.groupName;

      swal({
        className: "swal-reception-number-check",
        text: "Are you sure to " + status + " user group named " + groupName +"?",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Cancel',
          dangerMode: {
            text: "Ok",
            value: "action",
            className: "okay-btn"
          }
        },
      }).then((value) => {
        switch (value) {
          case "action":
            this.userGroupActivationUpdate_(index, userGroup.status);
            break;
          default:
            break;
        }
      });
    }

  };

  userGroupActivationUpdate_ = (index, status) => {
    let userGroups = this.state.userGroups;
    if(userGroups) {
      let userGroup = userGroups[index];

      let obj = {
        userGroupId :userGroup.userGroupId,
        groupName : userGroup.groupName,
        groupDesc : userGroup.groupDesc,
        users : [],
        corporateId :userGroup.corporateId,
        status : status!==1?1:0
      };
      let status_text = status!==1?"activated":"deactivated";
      let corporateId = this.props.usr_obj.corporates[0].corporateId;
      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
      };
      this.props.spinnerHandler(true);
      if(corporateId !== -1 && corporateId !== null && corporateId !== undefined) {
        axios.post(apiConfig.UPDATE_CORPORATE_USER_GROUP, obj,{headers:headers}).then(r =>{
          if(r.status === 200) {
            if (r.data.success) {
              common.warningAlert(userGroup.groupName + " user group had" + status_text + " successfully!", 0);
              this.getAllUserGroupOfCorporate();
            } else {
              common.warningAlert("Something went wrong!", 1)
            }
          }
        }).catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.userGroupActivationUpdate_(index, status);
          }
        }).finally(fin => {
          this.props.spinnerHandler(false);
        });

      }

    }
  };

  closeCreateModal = () => {
    let userGroup = this.props.user_group;
    this.setState({createModal: false});
    if(userGroup!==null) {
      this.setState({userModal: true});
    }
    // else {
    //   this.getAllUserGroupOfCorporate();
    // }
    this.getAllUserGroupOfCorporate();
  };

  closeUpdateModal = () => {
    this.setState({updateModal: false});
    this.getAllUserGroupOfCorporate();
  };

  closeUserModal = () => {
    this.setState({userModal: false});
    this.getAllUserGroupOfCorporate();
  };

  render() {
    let {updateModal, createModal, userModal, userGroups, userGroup, corporateId, corporateName} = this.state;

    let row = [];

    if(userGroups!==null) {
      userGroups.map((r, i)=>{
        let obj = {
          user_group_code: r.userGroupId,
          user_group_name: r.groupName,
          create_by: r.createdBy,
          create_datetime: r.createdDate,
          last_modify_by: r.modufyBy, // in modal of json give this property as modufy, not modify
          modified_datetime: r.modifyDate,
          active:
            <div>
              <Radio toggle checked={ r.status!==1?false:true } onChange={()=>this.userGroupActivationUpdate(i)}/>
            </div>,
          edit: <div>
            <SementicBtn
              circular
              icon='edit'
              onClick={() => this.updateUserGroup(r)}
            />
          </div>,
          users: <div>
            <SementicBtn
              circular
              icon='users'
              onClick={() => this.navToUsers(r)}
            />
          </div>,
        }
        row.push(obj);
      });

    }

    let draftData = {columns: tbl_headers.USER_GROUPS_TBL_HEADERS, rows: row};
    return(
      <div>
        {
          createModal?
          <CreateUserGroupModal isOpen={ true } corporateId={ corporateId } corporateName={ corporateName } closeModal={ this.closeCreateModal }/>:null
        }
        {
          updateModal?
          <UpdateUserGroupModal isOpen={ true } userGroup={ userGroup } corporateName={ corporateName } closeModal={ this.closeUpdateModal } />:null
        }
        {
          userModal?
          <AddUsersModal isOpen={ true } userGroupDetails={ this.props.user_group } closeModal={ this.closeUserModal } />:null
        }
        <Row>
          <Col lg={"12"} style={{marginBottom: '5px', marginTop: '10px', textAlign: "end"}}>
            <Button
              className="px-5"
              onClick={this.createUserGroup}
            ><i aria-hidden="true" className="plus icon"></i>
              New User Group
            </Button>
          </Col>
          <Col>
            <Card>
              <CardHeader>
                All User Groups
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <MDBDataTable
                    searching={true}
                    displayEntries={true}
                    responsive
                    responsiveSm
                    responsiveMd
                    responsiveLg
                    responsiveXl
                    bordered
                    hover
                    data={draftData}
                  />
                  {/*:*/}
                  {/*<div className={"align-center fully-width"}>*/}
                  {/*  <Empty description={"Records not found"} className={"empty-icon"}/>*/}
                  {/*</div>*/}
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user_group: state.userGroupReducer.userGroupDetails,
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setUserGroupHandler: (data) => dispatch(actionCreator.saveUserGroupDetails(data)),
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AllUserGroupsComponent));
